module.exports = __webpack_public_path__ + "img/104_doc_front.5fce4a77.svg";